/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GemColor from './GemColor';
import GemEffect from './GemEffect';
import MaterialType from './MaterialType';
import TokenType from './TokenType';

/**
 * The Material model module.
 * @module model/Material
 * @version 1.0
 */
class Material {
    /**
     * Constructs a new <code>Material</code>.
     * @alias module:model/Material
     */
    constructor() { 
        
        Material.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Material</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Material} obj Optional instance to populate.
     * @return {module:model/Material} The populated <code>Material</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Material();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemName')) {
                obj['itemName'] = ApiClient.convertToType(data['itemName'], 'String');
            }
            if (data.hasOwnProperty('itemType')) {
                obj['itemType'] = MaterialType.constructFromObject(data['itemType']);
            }
            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('coinType')) {
                obj['coinType'] = TokenType.constructFromObject(data['coinType']);
            }
            if (data.hasOwnProperty('property1')) {
                obj['property1'] = ApiClient.convertToType(data['property1'], 'Number');
            }
            if (data.hasOwnProperty('property2')) {
                obj['property2'] = ApiClient.convertToType(data['property2'], 'Number');
            }
            if (data.hasOwnProperty('property3')) {
                obj['property3'] = ApiClient.convertToType(data['property3'], 'Number');
            }
            if (data.hasOwnProperty('gemColor')) {
                obj['gemColor'] = GemColor.constructFromObject(data['gemColor']);
            }
            if (data.hasOwnProperty('gemEffect')) {
                obj['gemEffect'] = GemEffect.constructFromObject(data['gemEffect']);
            }
            if (data.hasOwnProperty('gemEffectValue')) {
                obj['gemEffectValue'] = ApiClient.convertToType(data['gemEffectValue'], 'Number');
            }
            if (data.hasOwnProperty('upgradeItemId')) {
                obj['upgradeItemId'] = ApiClient.convertToType(data['upgradeItemId'], 'Number');
            }
            if (data.hasOwnProperty('expireAt')) {
                obj['expireAt'] = ApiClient.convertToType(data['expireAt'], 'Date');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Material</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Material</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['itemName'] && !(typeof data['itemName'] === 'string' || data['itemName'] instanceof String)) {
            throw new Error("Expected the field `itemName` to be a primitive type in the JSON string but got " + data['itemName']);
        }

        return true;
    }


}



/**
 * @member {Number} itemId
 */
Material.prototype['itemId'] = undefined;

/**
 * @member {String} itemName
 */
Material.prototype['itemName'] = undefined;

/**
 * @member {module:model/MaterialType} itemType
 */
Material.prototype['itemType'] = undefined;

/**
 * @member {Number} level
 */
Material.prototype['level'] = undefined;

/**
 * @member {module:model/TokenType} coinType
 */
Material.prototype['coinType'] = undefined;

/**
 * @member {Number} property1
 */
Material.prototype['property1'] = undefined;

/**
 * @member {Number} property2
 */
Material.prototype['property2'] = undefined;

/**
 * @member {Number} property3
 */
Material.prototype['property3'] = undefined;

/**
 * @member {module:model/GemColor} gemColor
 */
Material.prototype['gemColor'] = undefined;

/**
 * @member {module:model/GemEffect} gemEffect
 */
Material.prototype['gemEffect'] = undefined;

/**
 * @member {Number} gemEffectValue
 */
Material.prototype['gemEffectValue'] = undefined;

/**
 * @member {Number} upgradeItemId
 */
Material.prototype['upgradeItemId'] = undefined;

/**
 * @member {Date} expireAt
 */
Material.prototype['expireAt'] = undefined;

/**
 * @member {Number} sort
 */
Material.prototype['sort'] = undefined;






export default Material;

